import { Component, OnDestroy, OnInit } from '@angular/core';
import { LenderCompanyMessageModel } from '../../model/data-message.model';
import { CreateUpdateComponent } from '../create-update.component';

@Component({
	selector: 'cv-invision-create-update-lender-company-message',
	templateUrl: './create-update-lender-company-message.component.html',
	styleUrls: ['./create-update-lender-company-message.component.scss']
})
export class CreateUpdateLenderCompanyMessageComponent extends CreateUpdateComponent implements OnInit, OnDestroy {
	public config: any = new LenderCompanyMessageModel();
	public originalConfig: any = new LenderCompanyMessageModel();

	ngOnInit(): void {
		super.ngOnInit();

		if (!this.data.isEditing) {
			this.config = {
				acuityMessage: '',
				appScopeMessage: '',
				nexsysLenderCompanyId: ''
			};
		}
	}

	/**
	 * Is form valid?
	 */
	setIsFormValid(): boolean {
		return this.config.nexsysLenderCompanyId.trim().length > 0 &&
			this.config.appScopeMessage.trim().length > 0 &&
			this.config.acuityMessage.trim().length > 0 &&
			this.isDirty();
	}
}
